<template>
	<div class="operation flex">
		<div class="img">
			<img src="@/assets/public/ecommerce.png" alt="" />
		</div>
		<div class="box flex flex-just-between">
			<div class="left">
				<h6 class="fz-16 sign">报名须知</h6>
				<p class="fz-14 mt-8">1、暂不支持“托管商品”、“二级团长商品”报名其他团长活动；</p>
				<p class="fz-14 mt-6">2、实际已报名的商品，再次报名会提示“报名失败”，可以在“报名失败”列表手动设为已报名；</p>
				<p class="fz-14 mt-6">3、由于服务费等原因报名失败的商品，可以在“报名失败”列表找到，并重新报名活动</p>
			</div>
			<div class="right flex flex-align-center">
				<!-- <p class="fz-16 mr-6 desc">查看操作手册</p>
                <i class="iconfont icon-a-right-circle-oxiangyou-yuan-xian"></i> -->
			</div>
		</div>
	</div>
</template>
<script>
export default {};
</script>
<style lang="less" scoped>
.operation {
	background-color: #facc14;
	padding: 10px;
	border-radius: 2px;
	.img {
		width: 100px;
		height: 100px;
	}
	.box {
		flex: 1;
		padding: 9px 12px;
		border-radius: 4px;
		border: 3px solid #c8a310;
		background-color: #fff;
	}
	.sign,
	.desc {
		color: #3b3b3b;
		font-weight: bold;
	}
}
</style>